'use client'

import { useEffect } from 'react';
import { throttle } from 'lodash';
import useGeneralStore from '@/lib/hooks/zustand-stores/general-store'

export default function useViewportListener (breakpoint: number = 768): void {
  const setIsMobile = useGeneralStore((state) => state.setIsMobile);

  useEffect(() => {
    const handleResize = throttle(() => {
      if (typeof window !== 'undefined') {
        setIsMobile(window.innerWidth <= breakpoint);
      }
    }, 200);

    handleResize();

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', handleResize);
      return () => {
        handleResize.cancel();
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [breakpoint, setIsMobile]);
};
